"use client";
import React, { useState } from "react";
import makeApiCall from "@packages/lib/server-actions/rest-api";
import API_URL from "@packages/lib/server-actions/api-urls";
import {
  clickstreamForClicks,
  gaForCtaClicks,
  oldGAForCtaClicks
} from "@packages/lib/utlils/commonFunction";
import { ClickstreamConstants } from "@packages/shared-components/services/constants";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import ButtonLoader from "./ButtonLoader";
const ApplyNow = ({
  enquiryProps,
  commonGAAttrs,
  btnSize = "w-full",
  btnName,
  commonOldGAAttrs
}: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const csData: ClickstreamInterface = {
    CTATitle: ClickstreamConstants.applyNowCTA,
    actionType: ClickstreamConstants.clickAction,
    functionalityName:
      enquiryProps?.sponsoredListingFlag === "Y"
        ? ClickstreamConstants.sponsorListing
        : ClickstreamConstants.applyNowCTA,
    eventType: ClickstreamConstants.applyNowEvent,
  };

  const handleApplyNow = async () => {
    setIsLoading(true);
    const applyNowPayload = {
      suborderItemId: enquiryProps?.subOrderItemId,
      orderItemId: enquiryProps?.orderItemId,
      collegeId: enquiryProps?.collegeId,
      courseId: enquiryProps?.courseId,
      affiliateId: process.env.AFFILATE_ID,
      qualCode: enquiryProps?.qualCode,
    };
    if (commonGAAttrs) {
      commonGAAttrs.study_mode = enquiryProps?.studyMode;
    }

    try {
      const response = await makeApiCall({
        url: `${process.env.NEXT_PUBLIC_DOMSERVICE_API_DOMAIN}/${API_URL?.getEnquiryDetails}`,
        method: "POST",
        queryParams: {},
        body: applyNowPayload,
        headers: {
          "x-api-key": `${process.env.NEXT_PUBLIC_DOMSERVICE_X_API_KEY}`,
        },
      });
      const applyUrl = response?.stdApplyNowUrl || response?.applyNowUrl;
      if (applyUrl) {
        csData.externalUrl = applyUrl;
        enquiryProps.url = applyUrl
        enquiryProps.revenueValue = response?.applynowPrice
        commonGAAttrs.click_text = csData.CTATitle
        gaForCtaClicks(
          enquiryProps,
          "apply_now",
          commonGAAttrs,
          response.cpeFlag,
          ""
        );
       enquiryProps.event = "apply_now_click"
       oldGAForCtaClicks(
               enquiryProps,
               "Apply now",
               enquiryProps.url,
               enquiryProps.event,  
               commonOldGAAttrs,
               response.cpeFlag,
               ""
             );
        await clickstreamForClicks(enquiryProps, csData, commonGAAttrs);
        window.open(applyUrl, "_blank");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching enquiry data:", error);
    }
  };
  return (
    <button
      type="button"
      className={`btn btn-orange flex items-center justify-center ${btnSize}`}
      onClick={handleApplyNow}
    >
      <ButtonLoader isLoading={isLoading}>
        {btnName || ClickstreamConstants.applyNowCTA}
      </ButtonLoader>
    </button>
  );
};

export default ApplyNow;
